import React from "react";
import { Stack, MessageBar, MessageBarType } from "@fluentui/react";

/**
 * Warning message bar for new revision validation errors.
 */
function RevisionValidationMessageBar({ show, message }) {
  if (!show || !message) return null;
  return (
    <Stack.Item grow style={{ marginTop: "10px", width: "100%" }}>
      <MessageBar messageBarType={MessageBarType.warning}>{message}</MessageBar>
    </Stack.Item>
  );
}

export default RevisionValidationMessageBar;
